import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const phoneNumber = '972502768005'; // 050-276-8005
  const message = encodeURIComponent('שלום! אני מעוניין/ת לקבל מידע נוסף על House Of Fitness');

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <>
      {isVisible && (
        <div className="whatsapp-button-container">
          <button
            onClick={handleClick}
            className="whatsapp-button"
            aria-label="WhatsApp"
          >
            <MessageCircle size={28} />
          </button>
          
          {/* Tooltip */}
          <div className="whatsapp-tooltip">
            צריך עזרה? שלח לנו הודעה!
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
